import { useCallback, useEffect, useRef, useState } from "react";

const usePendingRequests = () => {
  const mountedRef = useRef(true);
  const pendingCountRef = useRef(0);
  const [pendingCount, setPendingCount] = useState(0);

  useEffect(() => {
    mountedRef.current = true;

    return () => {
      mountedRef.current = false;
      pendingCountRef.current = 0;
    };
  }, []);

  const beginRequest = useCallback(() => {
    let finished = false;

    pendingCountRef.current += 1;
    if (mountedRef.current) {
      setPendingCount(pendingCountRef.current);
    }

    return () => {
      if (finished) return;
      finished = true;

      pendingCountRef.current = Math.max(0, pendingCountRef.current - 1);
      if (mountedRef.current) {
        setPendingCount(pendingCountRef.current);
      }
    };
  }, []);

  const trackRequest = useCallback(
    async requestOrFactory => {
      const endRequest = beginRequest();

      try {
        return await (
          typeof requestOrFactory === "function"
            ? requestOrFactory()
            : requestOrFactory
        );
      } finally {
        endRequest();
      }
    },
    [beginRequest]
  );

  return {
    beginRequest,
    trackRequest,
    pendingCount,
    loading: pendingCount > 0,
  };
};

export default usePendingRequests;
